//@flow

// Vendors
import React from 'react';
import { useSelector } from 'react-redux';

// Routes
import { RoutesAuthBasic } from '../../../routes';

// Components
import { Footer } from '../../../components';
import Alert from 'texkit/dist/components/Alert/Alert';
import DefaultLayoutTransition from '../../DefaultLayoutTransition/DefaultLayoutTransition';
import PrivateLayoutBase from '../PrivateLayoutBase';

// Helpers
import { translateStateAlert } from '../../../lib/helpers';

// Styles
import './basic-private-layout.scss';

function BasicPrivateLayout() {
  const { alert } = useSelector(state => state);

  return (
    <PrivateLayoutBase>
      <DefaultLayoutTransition>
        <div className="layout basic-private-layout">
          {alert.info && <Alert alert={translateStateAlert(alert)} />}
          <RoutesAuthBasic />
          <Footer />
        </div>
      </DefaultLayoutTransition>
    </PrivateLayoutBase>
  );
}

export default BasicPrivateLayout;
